import { useEffect, useState } from "react";

export function useScrollTracker(ref, storageName) {
    const [scrollInfo, setScrollInfo] = useState({
      scrollTop: 0,
      scrollPercentage: 0,
    });
  
    useEffect(() => {
      const currentDiv = ref.current;
  
      const handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;
  
        setScrollInfo({
          scrollTop,
          scrollPercentage:
            (scrollTop / (scrollHeight - clientHeight)) * 100 || 0,
        });
  
        localStorage.setItem(`${storageName}-scrollPos`, scrollTop);
      };
  
      if (currentDiv) {
        currentDiv.addEventListener("scroll", handleScroll);
  
        return () => {
          currentDiv.removeEventListener("scroll", handleScroll);
        };
      }
    }, [ref]);
  
    return scrollInfo;
  }
  